/**
 * User-facing copy for Liveblocks `ROOM_CONNECTION_ERROR` codes.
 * Keep in sync with Liveblocks docs (auth, forbidden, room full, room id).
 */
export function getRoomConnectionErrorCopy(code: number): {
  title: string;
  description: string;
} {
  switch (code) {
    case 4001:
      return {
        title: "You do not have access to this canvas.",
        description:
          "Your account does not have permission to open this canvas, or the link may be incorrect.",
      };
    case -1:
      return {
        title: "Could not connect to collaboration.",
        description:
          "We could not verify your session for real-time editing. Try refreshing the page.",
      };
    case 4005:
      return {
        title: "This canvas is full.",
        description:
          "Too many people are viewing this canvas at once. Try again in a few minutes.",
      };
    case 4006:
      return {
        title: "This canvas session is out of date.",
        description:
          "The canvas room was updated. Refresh the page to load the latest version.",
      };
    default:
      return {
        title: "Something went wrong.",
        description:
          "We could not connect to real-time collaboration. Try refreshing the page.",
      };
  }
}
